import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import recognitionService from "./recognitionService"

const initialState = {
    donors: [],
    isLoading: false,
    isError: false,
    pageContent: {},
}

export const fetchDonors = createAsyncThunk(
    "recognitions/fetchDonors",
    async (_, thunkAPI) => {
        try {
            return await recognitionService.fetchDonors()
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString()
            return thunkAPI.rejectWithValue(message)
        }
    }
)

export const fetchPageContent = createAsyncThunk(
    "recognitions/fetchPageContent",
    async (slug, thunkAPI) => {
        try {
            return await recognitionService.fetchPageContent(slug)
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString()
            return thunkAPI.rejectWithValue(message)
        }
    }
)

export const recognitionSlice = createSlice({
    name: "recognitions",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDonors.pending, (state) => {
                state.isLoading = true
            })
            .addCase(fetchDonors.fulfilled, (state, action) => {
                state.isLoading = false
                state.donors = action.payload
            })
            .addCase(fetchDonors.rejected, (state, action) => {
                state.isError = true
                state.isLoading = false
                state.donors = []
                state.errorMessage = action.payload
            })
            .addCase(fetchPageContent.fulfilled, (state, action) => {
                state.pageContent = action.payload
            })
            .addCase(fetchPageContent.rejected, (state) => {
                state.pageContent = {}
            })
    },
})

export default recognitionSlice.reducer
